export enum Region {
    Fra = 'fra',
    Nyc = 'nyc',
    Syd = 'syd',
    Sfo = 'sfo',
    Sgp = 'sgp',
    Tor = 'tor',
}
